// OSS上传
export const OSS_URL = 'https://oss.byrobot.cn/oss/upload';
export const OSS_BUCKET = 'by-fe-cdn';
